"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScreenClassContext = exports.NO_PROVIDER_FLAG = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var utils_1 = require("../../utils");
var config_1 = require("../../config");
exports.NO_PROVIDER_FLAG = 'NO_PROVIDER_FLAG';
exports.ScreenClassContext = (0, react_1.createContext)(exports.NO_PROVIDER_FLAG);
var ScreenClassProvider = function (_a) {
    var useOwnWidth = _a.useOwnWidth, children = _a.children, fallbackScreenClass = _a.fallbackScreenClass;
    var screenClassRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)(false), 2), mounted = _b[0], setMounted = _b[1];
    var detectedScreenClass = (0, utils_1.useScreenClass)(screenClassRef, fallbackScreenClass);
    var defaultScreenClass = (0, config_1.getConfiguration)().defaultScreenClass;
    var screenClass = mounted ? detectedScreenClass : fallbackScreenClass || defaultScreenClass;
    (0, react_1.useEffect)(function () { return setMounted(true); }, []);
    return ((0, jsx_runtime_1.jsx)(exports.ScreenClassContext.Provider, __assign({ value: screenClass }, { children: useOwnWidth ? ((0, jsx_runtime_1.jsx)("div", __assign({ ref: useOwnWidth ? screenClassRef : null }, { children: children }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children })) })));
};
ScreenClassProvider.defaultProps = {
    useOwnWidth: false,
    fallbackScreenClass: null,
};
exports.default = ScreenClassProvider;
//# sourceMappingURL=index.js.map